import { http } from "utils/http";
import { getEnv } from "config/runtimeEnv";

function blobToBase64(blob) {
    return new Promise((resolve, _) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.readAsDataURL(blob);
    });
  }
export const loadCardImageWithSize = (async (attachId,size='256') => await http({
  baseURL:getEnv("REACT_APP_FILEDOWNLOAD_SERVICE_URL"),
    url:"file/Thumbnail/"+attachId+"?size="+size,
    method: 'get',
     responseType: "blob"
}).then((res) => {

    return blobToBase64( res.data)	
}).catch((err) => {
 
    return Promise.reject( err);
})

)
